import type { WireAuthProviderAdminRecord } from '#layers/access/utils/auth-providers/wire';
import { RStoreSchema } from '#imports';

export const AuthProvider = RStoreSchema.withItemType<WireAuthProviderAdminRecord>().defineCollection({
	name: 'MonospaceAuthProvider',
	scopeId: 'monospace-default',
	meta: {
		// `config` is selected so the edit dialog can prefill a provider's stored
		// settings. The admin read returns it as native JSON (never `clientSecret`,
		// which is write-only).
		defaultFields: ['id', 'apiName', 'preset', 'state', 'protocol', 'config'],
		endpoint: 'system/auth-providers',
	},
});
